
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Calendar from './pages/Calendar';
import Patients from './pages/Patients';
import Accounting from './pages/Accounting';
import Settings from './pages/Settings';
import WaitingRoom from './pages/WaitingRoom';
import Reports from './pages/Reports';
import Reminders from './pages/Reminders';
import ConfirmedAppointments from './pages/ConfirmedAppointments';
import Staff from './pages/Staff';
import StaffPermissions from './pages/StaffPermissions';
import Locations from './pages/Locations';
import Studies from './pages/Studies';
import Insurances from './pages/Insurances';
import EmailSettings from './pages/EmailSettings';
import PublicSettings from './pages/PublicSettings';
import PortalSettings from './pages/PortalSettings';
import OnlineBooking from './pages/OnlineBooking';
import Telemedicine from './pages/Telemedicine';
import Vademecum from './pages/Vademecum';
import Prescriptions from './pages/Prescriptions';
import WhatsAppManual from './pages/WhatsAppManual';
import MercadoPago from './pages/MercadoPago';
import ModulePlaceholder from './pages/ModulePlaceholder';
import Holidays from './pages/Holidays';
import AppointmentReasons from './pages/AppointmentReasons';
import GeneralSettings from './pages/GeneralSettings';
import PatientDetailPage from './pages/PatientDetailPage';

import { NotificationProvider } from './context/NotificationContext';
import { SearchProvider } from './context/SearchContext';

import PatientPortal from './pages/PatientPortal';
import ErrorBoundary from './components/ErrorBoundary';
import PublicConfirm from './pages/PublicConfirm';
import StaffLogin from './pages/StaffLogin';
import PatientsCaller from './pages/PatientsCaller';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <NotificationProvider>
      <SearchProvider>
        <ErrorBoundary>
        <Router>
        <Routes>
          {/* Public Patient Portal Route without Admin Sidebar */}
          <Route path="/portal" element={<PatientPortal />} />
          <Route path="/confirmar-turno/:id" element={<PublicConfirm />} />
          <Route path="/login/staff" element={<StaffLogin />} />
          <Route path="/patients-caller" element={<PatientsCaller />} />
          
          {/* Admin Routes with Sidebar */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="patients" element={<Patients />} />
              <Route path="patients/:id" element={<PatientDetailPage />} />
              <Route path="waiting-room" element={<WaitingRoom />} />
              <Route path="accounting" element={<Accounting />} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="confirmed" element={<ConfirmedAppointments />} />
              <Route path="reports" element={<Reports />} />
              <Route path="settings" element={<Settings />} />
              
              {/* New Expanded Routes */}
              <Route path="whatsapp-manual" element={<WhatsAppManual />} />
              <Route path="payments/mercadopago" element={<MercadoPago />} />
              <Route path="prescriptions" element={<Prescriptions />} />
              <Route path="plan" element={<ModulePlaceholder title="Mi Plan GDT" description="Consulta el estado de tu suscripción y gestiona tus pagos." />} />
              <Route path="recommend" element={<ModulePlaceholder title="Recomienda GDT" description="Invita a otros profesionales y obtén beneficios en tu plan." />} />
              
              <Route path="staff" element={<Staff />} />
              <Route path="staff/permissions" element={<StaffPermissions />} />
              
              <Route path="office/locations" element={<Locations />} />
              <Route path="office/studies" element={<Studies />} />
              <Route path="office/insurances" element={<Insurances />} />
              <Route path="office/emails" element={<EmailSettings />} />
              <Route path="office/public" element={<PublicSettings />} />
              
              <Route path="portal/settings" element={<PortalSettings />} />
              <Route path="portal/booking" element={<OnlineBooking />} />
              
              <Route path="telemedicine" element={<Telemedicine />} />
              <Route path="vademecum" element={<Vademecum />} />
              <Route path="tools/import" element={<ModulePlaceholder title="Importar Datos" description="Sube tus archivos CSV o Excel para migrar pacientes y turnos." />} />
              <Route path="help" element={<ModulePlaceholder title="Centro de Ayuda" description="Accede a tutoriales y soporte técnico para tu consultorio." />} />
              <Route path="app" element={<ModulePlaceholder title="App para Celulares" description="Descarga la aplicación móvil para gestionar tu agenda en cualquier lugar." />} />
              
              {/* Settings Sub-routes */}
              <Route path="settings/users" element={<ModulePlaceholder title="Usuarios y Permisos" description="Gestione los accesos y roles de su equipo de trabajo." />} />
              <Route path="settings/general" element={<GeneralSettings />} />
              <Route path="settings/templates-medical" element={<ModulePlaceholder title="Plantillas para Evoluc. e Informes" description="Cree y gestione plantillas predefinidas para sus historias clínicas." />} />
              <Route path="settings/holidays" element={<Holidays />} />
              <Route path="settings/patient-types" element={<ModulePlaceholder title="Tipos de Pacientes" description="Categorice a sus pacientes para un mejor seguimiento estadístico." />} />
              <Route path="settings/appointment-reasons" element={<AppointmentReasons />} />
              <Route path="settings/appointment-types" element={<ModulePlaceholder title="Tipos de Turno / Servicio" description="Configure duraciones y colores específicos para cada tipo de atención." />} />
              <Route path="settings/appointment-tags" element={<ModulePlaceholder title="Tags de Turnos" description="Etiquetas personalizadas para organizar visualmente su agenda." />} />
              <Route path="settings/accounting-types" element={<ModulePlaceholder title="Tipos de Caja" description="Organice sus ingresos y egresos por categorías personalizadas." />} />
              <Route path="settings/templates-orders" element={<ModulePlaceholder title="Plantillas para Órdenes Médicas" description="Agilice la emisión de órdenes y estudios frecuentes." />} />
              <Route path="settings/consultory-caller" element={<ModulePlaceholder title="Llamador a Consultorios" description="Gestione la fila de espera y llame a sus pacientes por pantalla." />} />

              <Route path="login" element={<ModulePlaceholder title="Iniciar Sesión" description="Pantalla de acceso al sistema." />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
          </Route>
        </Routes>
        </Router>
        </ErrorBoundary>
      </SearchProvider>
    </NotificationProvider>
  );
}

export default App;
